import React from 'react'
import BreadcrumbTab from '../../../../common/BreadcrumbTab'
import RMAReturnDetails from '../../Forms/RMAReturnDetails'
import { RMADetailBox1, RMADetailBox2 } from '../../style/RMA.css'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import { RMADetailWrapperWMO, RMADetailBoxWMO, Heading } from '../../style/RMAWMO.css'

const DisplayRMAReturnDetails = ({ moduleData }) => {
  const {
    isDesktop,
    showTabs,
    Link,
    isBot,
    forceMultipleSelect,
    cancelReturn,
    data,
    tabData,
    loading,
    setLoading,
    setDoneReturn,
    handleReason,
    appSteps,
    setAppSteps,
    imgSteps,
    setImgSteps,
    customerOrder,
    fileUpload,
    setFileUpload,
    formFile,
    setFormFile,
    tempStep,
    setTempStep,
    reqElem,
    setReqElem,
    partSku,
    GTM,
    setReturnQuantity,
    returnQuantity,
    setCustomerOrder,
    tokenCustomerId,
    setShowTabs,
    formFileMain,
    setFormFileMain,
    mechanicDiagnosis,
    docSteps,
    setDocSteps,
    returnReasonUtils,
    returnDetailsData,
    creditStatus,
    returnRequestStatus,
    setReturnDetailsData,
    setDisplayReturnDetails,
    OpenChatHandler,
  } = { ...moduleData }

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (
      <RMADetailWrapperWMO>
        {showTabs && (
          <Heading>
            Return a Part
          </Heading>
        )}
        <RMADetailBoxWMO showTabs={showTabs}>
          <RMAReturnDetails
            key="returnDetails"
            isDesktop={isDesktop}
            Link={Link}
            isBot={isBot}
            forceMultipleSelect={forceMultipleSelect}
            data={data}
            onCancelReturn={cancelReturn}
            loading={loading}
            setLoading={setLoading}
            setDoneReturn={setDoneReturn}
            handleReason={handleReason}
            appSteps={appSteps}
            setAppSteps={setAppSteps}
            imgSteps={imgSteps}
            setImgSteps={setImgSteps}
            customerOrder={customerOrder}
            fileUpload={fileUpload}
            setFileUpload={setFileUpload}
            formFile={formFile}
            setFormFile={setFormFile}
            tempStep={tempStep}
            setTempStep={setTempStep}
            reqElem={reqElem}
            setReqElem={setReqElem}
            partSku={partSku}
            GTM={GTM}
            setReturnQuantity={setReturnQuantity}
            returnQuantity={returnQuantity}
            setCustomerOrder={setCustomerOrder}
            tokenCustomerId={tokenCustomerId}
            showTabs={showTabs}
            setShowTabs={setShowTabs}
            formFileMain={formFileMain}
            setFormFileMain={setFormFileMain}
            mechanicDiagnosis={mechanicDiagnosis}
            docSteps={docSteps}
            setDocSteps={setDocSteps}
            returnReasonUtils={returnReasonUtils}
            returnDetailsData={returnDetailsData}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            OpenChatHandler={OpenChatHandler}
          />
        </RMADetailBoxWMO>
      </RMADetailWrapperWMO>
    )
  }

  return (
    <RMADetailBox1>
      <RMADetailBox2>
        {showTabs && (
          <BreadcrumbTab
            key="breadcrumbTab"
            data={tabData}
            bgColor="#a3a3a3"
            bgActiveColor="#333"
            activeStep={0}
          />
        )}
         <RMAReturnDetails
          key="returnDetails"
          isDesktop={isDesktop}
          Link={Link}
          isBot={isBot}
          forceMultipleSelect={forceMultipleSelect}
          data={data}
          onCancelReturn={cancelReturn}
          loading={loading}
          setLoading={setLoading}
          setDoneReturn={setDoneReturn}
          handleReason={handleReason}
          appSteps={appSteps}
          setAppSteps={setAppSteps}
          imgSteps={imgSteps}
          setImgSteps={setImgSteps}
          customerOrder={customerOrder}
          fileUpload={fileUpload}
          setFileUpload={setFileUpload}
          formFile={formFile}
          setFormFile={setFormFile}
          tempStep={tempStep}
          setTempStep={setTempStep}
          reqElem={reqElem}
          setReqElem={setReqElem}
          partSku={partSku}
          GTM={GTM}
          setReturnQuantity={setReturnQuantity}
          returnQuantity={returnQuantity}
          setCustomerOrder={setCustomerOrder}
          tokenCustomerId={tokenCustomerId}
          showTabs={showTabs}
          setShowTabs={setShowTabs}
          formFileMain={formFileMain}
          setFormFileMain={setFormFileMain}
          mechanicDiagnosis={mechanicDiagnosis}
          docSteps={docSteps}
          setDocSteps={setDocSteps}
          returnReasonUtils={returnReasonUtils}
          returnDetailsData={returnDetailsData}
          creditStatus={creditStatus}
          returnRequestStatus={returnRequestStatus}
          setReturnDetailsData={setReturnDetailsData}
          setDisplayReturnDetails={setDisplayReturnDetails}
          OpenChatHandler={OpenChatHandler}
        />
      </RMADetailBox2>
    </RMADetailBox1>
  )
}

export default DisplayRMAReturnDetails
